import React from "react";
import { CircularProgress, Button as MuiButton } from "@mui/material";

function Button(props) {
  const {
    text,
    size,
    color,
    variant,
    onClick,
    isLoading,
    colorLoading = "primary",
    ...other
  } = props;

  return (
    <MuiButton
      sx={{ margin: "4px" }}
      variant={variant || "contained"}
      size={size || "large"}
      color={color || "primary"}
      onClick={onClick}
      {...other}
    >
      {text}
      {isLoading ? (
        <CircularProgress
          size="15px"
          sx={{ marginLeft: "5px", color: `${colorLoading}` }}
        />
      ) : null}
    </MuiButton>
  );
}

export default Button;
